import CitySalaryPageTemplate from "@/components/CitySalaryPageTemplate";
import { CITY_SALARY_DATA } from "@/data/citySalaryData";

export default function DataScientistBangalore() {
  return <CitySalaryPageTemplate data={CITY_SALARY_DATA["data-scientist-bangalore"]} />;
}
